import React, { useEffect, useState } from 'react'

import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { ThemeProvider, createTheme, responsiveFontSizes } from '@mui/material';
import { useSelector } from 'react-redux';

import { useDispatch } from 'react-redux';

import theme from "../utils/theme";

import PrivateRoute from "../router/PrivateRoute";
import PublicRoute from "../router/PublicRoute";


import { getTheme } from '../redux/actions/uiAction';
import About from '../pages/About';
import Services from '../pages/Services';
import Works from '../pages/Works';
import Contact from '../pages/Contact';
import ErrorPage from '../pages/ErrorPage';
import LoadingPage from '../pages/LoadingPage';

import Login from '../pages/Login';
import Register from '../pages/Register';
import MobileLibrary from '../pages/MobileLibrary';
import LibraryCollection from '../pages/LibraryCollection';
import Ebooks from '../pages/Ebooks';
import { onAuthStateChanged } from 'firebase/auth';
import { getAuthorize } from '../utils/firebase';
import TransactionBorrowed from '../pages/TransactionReserve';
import Settings from '../pages/Settings';
import TransactionReturn from '../pages/TransactionReturn';
import TransactionPenalty from '../pages/TransactionPenalty';
import Notifications from '../pages/Notifications';
import Bookmarks from '../pages/Bookmarks';
import ReservationForm from '../pages/ReservationForm';
import Profile from '../pages/EditProfile';
import EditProfile from '../pages/EditProfile';
import { currentUser } from '../redux/actions/userAction';
import TransactionRequest from '../pages/TransactionRequest';

export default function Router() {
    const [state, setState] = useState({
        user: null,
        isAuth: false,
        isLoading: true
    });
    const dispatch = useDispatch();
    const mode = useSelector(state => state.ui);
    const user = useSelector(state => state.user);

    let THEME = createTheme(theme(mode.isDarkMode));
    THEME = responsiveFontSizes(THEME);
    useEffect(() => {
        dispatch(getTheme());
        onAuthStateChanged(getAuthorize, (user) => {
            if (user) {
                dispatch(currentUser(user.uid, user.email));
                setState({ user: user, isAuth: true, isLoading: false });
            } else {
                setState({ isAuth: false, isLoading: false });
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch])

    if (state.isLoading) {
        return <ThemeProvider theme={THEME}>
            <LoadingPage />
        </ThemeProvider>
    }

    if(user && !user.profileExist){
        return <ThemeProvider theme={THEME}>
            <EditProfile />
        </ThemeProvider>
    }
    return (
        <ThemeProvider theme={THEME}>
            <BrowserRouter>
                <Switch>
                    <Redirect exact from="/" to="/about" />
                    <PublicRoute
                        component={Login}
                        isAuth={state.isAuth}
                        restricted={true}
                        path="/login"
                        exact
                    />
                     <PublicRoute
                        component={Register}
                        isAuth={state.isAuth}
                        restricted={true}
                        path="/register"
                        exact
                    />
                    <PrivateRoute
                        component={TransactionBorrowed}
                        isAuth={state.isAuth}
                        path="/mybooks/reserve"
                        exact
                    />
                    <PrivateRoute
                        component={TransactionRequest}
                        isAuth={state.isAuth}
                        path="/mybooks/requests"
                        exact
                    />
                    <PrivateRoute
                        component={TransactionReturn}
                        isAuth={state.isAuth}
                        path="/mybooks/return"
                        exact
                    />
                    <PrivateRoute
                        component={TransactionPenalty}
                        isAuth={state.isAuth}
                        path="/mybooks/penalty"
                        exact
                    />
                    <PrivateRoute
                        component={Notifications}
                        isAuth={state.isAuth}
                        path="/notifications"
                        exact
                    />
                    <PrivateRoute
                        component={Settings}
                        isAuth={state.isAuth}
                        path="/settings"
                        exact
                    />
                    <PrivateRoute
                        component={Bookmarks}
                        isAuth={state.isAuth}
                        path="/bookmarks"
                        exact
                    />
                    <PrivateRoute
                        component={ReservationForm}
                        isAuth={state.isAuth}
                        path="/reservation"
                        exact
                    />
                    <PrivateRoute
                        component={Profile}
                        isAuth={state.isAuth}
                        path="/profile"
                        exact
                    />
                    <Route component={ErrorPage} path="/notfound" />
                    <Route component={About} path="/about" />
                    <Route component={Services} path="/services" />
                    <Route component={MobileLibrary} path="/mobilelibrary" />
                    <Route component={LibraryCollection} path="/librarycollections" />
                    <Route component={Ebooks} path="/ebooks" />
                    <Route component={Works} path="/works" />
                    <Route component={Contact} path="/contact" />
                    <Redirect path="" to="/notfound" />
                </Switch>
            </BrowserRouter>
        </ThemeProvider>
    )
}
